function escapeHtml(s) {
	if (s == null || s === '') return '—';
	return String(s)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

export function formatChatSessionDateTime() {
	try {
		return new Date().toLocaleString(undefined, {
			dateStyle: 'medium',
			timeStyle: 'short',
		});
	} catch (e) {
		return new Date().toISOString();
	}
}

export function readFullcontField(root, wrapperId) {
	if (!root || !wrapperId) return '';
	const wrap = root.querySelector(`#${wrapperId}`);
	if (!wrap) return '';
	const el = wrap.querySelector('input.elem, textarea.elem, select.elem');
	if (!el) return '';
	if (el.tagName === 'SELECT') {
		const opt = el.options[el.selectedIndex];
		return (opt && opt.text) ? String(opt.text).trim() : String(el.value || '').trim();
	}
	return String(el.value || '').trim();
}

export function countMultitableLines(root, containerId) {
	if (!root || !containerId) return 0;
	const cont = root.querySelector(`#${containerId}`);
	if (!cont) return 0;
	return cont.querySelectorAll('.line').length;
}

/** Nombre legible del módulo (evita mostrar códigos internos tipo "item", "sale"). */
export function friendlySectionName(dest) {
	const map = {
		item: 'Item',
		sale: 'Sale',
		purchase: 'Purchase',
		customer: 'Customer',
		provider: 'Provider',
		suggestion: 'Suggestion',
	};
	return map[dest] || dest || '—';
}

export function buildChatCardWarning(opts) {
	const entityDisplay = opts.entityDisplay || '—';
	const typeLabel = opts.typeLabel || '—';
	const recordId = opts.recordId != null && opts.recordId !== '' ? String(opts.recordId) : '—';
	const scopeNote = opts.scopeNote || '';
	const details = Array.isArray(opts.details) ? opts.details.filter((d) => d && d.label) : [];

	const when = formatChatSessionDateTime();

	let html = `
        <div class="row chat-card-warning-row">
            <div class="c25">
                <div class="chat-type-text">
                    <span class="chat-card-warning-k">Date and time</span><br>
                    ${escapeHtml(when)}
                </div>
            </div>
            <div class="c25">
                <div class="chat-type-text">
                    <span class="chat-card-warning-k">Section</span><br>
                    ${escapeHtml(entityDisplay)}
                </div>
            </div>
            <div class="c25">
                <div class="chat-type-text">
                    <span class="chat-card-warning-k">Query type</span><br>
                    ${escapeHtml(typeLabel)}
                </div>
            </div>
            <div class="c25">
                <div class="chat-type-text">
                    <span class="chat-card-warning-k">Reference number</span><br>
                    ${escapeHtml(recordId)}
                </div>
            </div>
        </div>`;

	for (let i = 0; i < details.length; i += 3) {
		const chunk = details.slice(i, i + 3);
		html += '<div class="row mt-6 chat-card-warning-row">';
		chunk.forEach((d) => {
			const v = d.value != null && String(d.value).trim() !== '' ? String(d.value).trim() : '—';
			html += `
            <div class="c33">
                <div class="chat-type-text">
                    <span class="chat-card-warning-k">${escapeHtml(d.label)}</span><br>
                    ${escapeHtml(v)}
                </div>
            </div>`;
		});
		html += '</div>';
	}

	if (scopeNote) {
		html += `
        <div class="row mt-8">
            <div class="c100">
                <div class="chat-type-text chat-card-warning-scope">${escapeHtml(scopeNote)}</div>
            </div>
        </div>`;
	}

	return html;
}
